// extracted by mini-css-extract-plugin
export var Body = "styles-module--Body--7T7yp";
export var Footer = "styles-module--Footer--15p87";
export var Login = "styles-module--Login--4veyc";
export var Message = "styles-module--Message--RjSPW";
export var Wrapper = "styles-module--Wrapper--yJmUn";